<template>
  <div class="alarm-tip" @click="openAlarmRecord" v-if="alarmList.length">
    <!-- <div class="alarm-tip-head">
      <WarningOutlined class="alarm-tip-icon" />
      <span>报警提示</span>
    </div> -->
    <div class="alarm-tip-body">
      <div
        class="alarm-tip-track"
        :style="{ transform: `translateY(-${currentIndex * 100}%)` }"
      >
        <div
          class="alarm-tip-item"
          v-for="(item, index) in alarmList"
          :key="index"
        >
          <WarningOutlined class="alarm-tip-icon" />
          <span class="fault-content">{{ item || "--" }}</span>
        </div>
      </div>
    </div>
    <!-- 报警记录表格弹框 -->
    <alarm-record v-if="alarmRecordShow" v-model:visible="alarmRecordShow" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { WarningOutlined } from "@ant-design/icons-vue";
import { apiTopHeader } from "../api/api-topHeader";
import alarmRecord from "./cpns/menu/alarm-record.vue";
import { useStore } from "vuex";

const store = useStore();

// 报警提示列表
const alarmList = ref([]);
// 当前轮播索引
const currentIndex = ref(0);
// 控制报警记录弹窗显示
const alarmRecordShow = ref(false);
// 轮播定时器
let carouselTimer = null;

/**
 * @introduction 开始上下轮播，5s 切换一条
 */
const startCarousel = () => {
  clearCarousel();
  carouselTimer = setInterval(() => {
    if (alarmList.value.length > 1) {
      currentIndex.value = (currentIndex.value + 1) % alarmList.value.length;
    }
  }, 5000);
};

/**
 * @introduction 清除轮播定时器，防止内存泄漏
 */
const clearCarousel = () => {
  if (carouselTimer) {
    clearInterval(carouselTimer);
    carouselTimer = null;
  }
};

/**
 * @introduction 点击打开报警记录弹窗
 */
const openAlarmRecord = () => {
  alarmRecordShow.value = true;
};

watch(
  () => store.state.engine.allEngineData,
  (newValue) => {
    if (newValue.deviceFaultCodeMap) {
      alarmList.value = Object.values(newValue.deviceFaultCodeMap).filter(
        (item) => item,
      );
    } else {
      alarmList.value = [];
    }
  },
  { immediate: true },
);

onMounted(() => {
  startCarousel();
});

onUnmounted(() => {
  clearCarousel();
});
</script>

<style lang="scss" scoped>
.alarm-tip {
  width: 100%;
  //   height: 100%;
  display: flex;
  align-items: center;
  column-gap: 0.08rem;
  padding: 0.05rem 0.1rem;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ff5e6f;
  background: rgba(120, 20, 30, 0.35);
  box-shadow: 0 0 14px rgba(255, 59, 48, 0.4);
  cursor: pointer;
  overflow: hidden;
  .alarm-tip-head {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    column-gap: 0.03rem;
    color: #ff8a95;
    font-size: 0.09rem;
    font-weight: bold;
    .alarm-tip-icon {
      font-size: 0.1rem;
    }
  }
  .alarm-tip-body {
    flex: 1;
    // 轮播视口必须为固定高度，否则百分比高度链失效导致多条同时展示
    height: 0.16rem;
    overflow: hidden;
    position: relative;
    .alarm-tip-track {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      transition: transform 0.5s ease;
    }
    .alarm-tip-item {
      flex: 0 0 100%;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 0.04rem;
      color: #ff5e6f;
      font-size: 0.09rem;
      font-weight: bold;
      white-space: nowrap;
      .device-name,
      .fault-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .fault-content {
        max-width: 60%;
      }
    }
    .alarm-tip-empty {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffb3bb;
      font-size: 0.09rem;
    }
  }
}
</style>
